import { useState } from "react"
import { DrinkEntity } from "../../Objects/MealsAndDrinks/DrinkEntity"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { GenericFoodEntity } from "../../Objects/MealsAndDrinks/GenericFoodEntity"

export const useCreateDrinks = () => {
  const [drink, setDrink] = useState<DrinkEntity | null>(null)

  const handleInitialValue = (drink: DrinkEntity | null | undefined) => {
    if (drink) {
      setDrink(drink)
    }
  }

  const handleSubmitForm = (genericFoodEntity: GenericFoodEntity): DrinkEntity | { errors: ValidationError[] } => {
    return new DrinkEntity({
      id: drink?.id,
      genericFoodEntity: genericFoodEntity!,
    })
  }

  return {
    drink,
    handleSubmitForm,
    handleInitialValue,
  }
}
